import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import surveyReducer from './slices/surveySlice';
import checkInReducer from './slices/checkInSlice';
import supportDeskReducer from './slices/supportDeskSlice';
import themeReducer from './slices/themeSlice';
import signupReducer from './slices/signupSlice';
import onboardingReducer from './slices/onboardingSlice';
import pipelineDebuggerReducer from './slices/pipelineDebuggerSlice';
import noteGenerationSandboxReducer from './slices/noteGenerationSandboxSlice';
import salesLeadsReducer from './slices/sales-module/salesLeadsSlice';
import salesOpportunityReducer from './slices/sales-module/salesOpportunitySlice';
import jobListingsReducer from './slices/sales-module/jobListingsSlice';
import referralReducer from './slices/referral-management/referralSlice';
import vcxEventsReducer from './slices/vcxEventsSlice';
import vcxEventActivitiesReducer from './slices/vcxEventActivitiesSlice';
import voiceAIAgentsReducer from './slices/voiceAIAgentsSlice';
import userPreferencesReducer from './slices/userPreferencesSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from '@reduxjs/toolkit';

// Configure persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'survey', 'checkIn', 'supportDesk', 'theme', 'signup', 'onboarding', 'noteGenerationSandbox', 'salesLeads', 'salesOpportunities', 'jobListings', 'referral', 'vcxEvents', 'vcxEventActivities', 'voiceAIAgents', 'userPreferences'],
};

const rootReducer = combineReducers({
  user: userReducer,
  survey: surveyReducer,
  checkIn: checkInReducer,
  supportDesk: supportDeskReducer,
  theme: themeReducer,
  signup: signupReducer,
  onboarding: onboardingReducer,
  pipelineDebugger: pipelineDebuggerReducer,
  noteGenerationSandbox: noteGenerationSandboxReducer,
  salesLeads: salesLeadsReducer,
  salesOpportunities: salesOpportunityReducer,
  jobListings: jobListingsReducer,
  referral: referralReducer,
  vcxEvents: vcxEventsReducer,
  vcxEventActivities: vcxEventActivitiesReducer,
  voiceAIAgents: voiceAIAgentsReducer,
  userPreferences: userPreferencesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };